// extracted by mini-css-extract-plugin
module.exports = {"ClubPreviewContainer":"ClubPreview-module--ClubPreviewContainer--L9IT2","ClubPreviewText":"ClubPreview-module--ClubPreviewText--1IDMF","Footer":"ClubPreview-module--Footer--2ijDg"};